import React, { useState } from 'react';
import { usePermissionContext } from "../../contexts/permission-context";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

// mui does not support a default TabPanel out of the box except in experimental lab package so create one from examples
import TabPanel from '../../components/TabPanel/TabPanel';

import PageHeader from "../../components/PageHeader/PageHeader";
import SystemIdpOAuthTabPanel from "./SystemIdpOAuthTabPanel";
import SystemAuditHistoryTabPanel from './SystemAuditHistoryTabPanel';
import SystemDbUpdateTabPanel from './SystemDbUpdateTabPanel';
import SystemUploaderTasksTabPanel from './SystemUploaderTasksTabPanel';
import SystemKafkaConsumerTabPanel from './SystemKafkaConsumerTabPanel';
import SystemMiscellaneousTabPanel from './SystemMiscellaneousTabPanel';
import SystemCspReportsTabPanel from './SystemCspReportsTabPanel';
import AlertSnackbar from '../../components/AlertSnackbar/AlertSnackbar';
import './system.scss';
import { getUser, platformManage, hasPermission } from '../../Utils/Common';
const System = () => {
  const { permissions } = usePermissionContext();
  const initialSnackbarState = {
    open: false,
    message: '',
    alertTitle: '',
    severity: 'info',
    hideDuration: 1000
  };
  const [createIdpOAuth, setCreateIdpOAuth] = useState(false);

  const [notify, setNotify] = useState(
    initialSnackbarState
  );

  // define names of tabs
  const tabs = [
    {
      label: 'IDP - OAuth2',
      value: 'processIDP',
      component: <SystemIdpOAuthTabPanel setNotify={setNotify} createIdpOAuth={createIdpOAuth} setOpenIdpOAuth={setCreateIdpOAuth} />
    },
    {
      label: 'Audit History',
      value: 'auditHistory',
      component: <SystemAuditHistoryTabPanel setNotify={setNotify} />
    },
    {
      label: 'Uploader Tasks',
      value: 'uploaderTasks',
      component: <SystemUploaderTasksTabPanel setNotify={setNotify} />
    },
    {
      label: 'DB Update',
      value: 'dbUpdate',
      component: <SystemDbUpdateTabPanel setNotify={setNotify} />
    },
    {
      label: 'Kafka Consumer',
      value: 'kafkaConsumer',
      component: <SystemKafkaConsumerTabPanel setNotify={setNotify} />
    },
    {
      label: 'CSP Reports',
      value: 'cspReports',
      component: <SystemCspReportsTabPanel setNotify={setNotify} />
    },
    {
      label: 'Miscellaneous',
      value: 'Miscellaneous',
      component: <SystemMiscellaneousTabPanel />
    }
  ];

  let selectedIndex = sessionStorage.getItem("system") !== null ? sessionStorage.getItem("system") : 0
  const [value, setValue] = useState(+selectedIndex);    // set to previous visited user tab
  const [selectedTab, setSelectedTab] = useState(tabs[value].value);

  const handleChange = (event, newValue) => {
    sessionStorage.setItem("system", newValue)
    setSelectedTab(tabs[newValue].value);

    setValue(newValue);
    getPageHeader();       // needed??
  };

  
  // initially we needed different page headers. Requirement was changed. Technically we don't need this but leaving for now
  const getPageHeader = () => {
    const isCreateEnabled = hasPermission(permissions, platformManage) && getUser() === 'irmuser_idp_admin';
    switch (selectedTab) {
      // common page header on all tabs
      case 'processIDP':
        return (<PageHeader title='System' createTitle='Create IDP OAuth2' includeCreate={isCreateEnabled} onCreate={onCreateIdpOAuth}  />);  // if need create button
      case 'auditHistory':
      case 'dbUpdate':
      case 'userSessions':
      case 'cspReports':
      default:
        return (<PageHeader title='System' includeCreate={false} />);
    }
  };

  const onCreateIdpOAuth = () => {
    // console.log("Create IdpOAuth2 button clicked");

    setCreateIdpOAuth(true);
};

  return (
    <>

      <AlertSnackbar
        notify={notify}
        setNotify={setNotify} />

      {getPageHeader()}

      <Tabs value={value} onChange={handleChange} aria-label="document tabs">
        {tabs.map((tab) => <Tab key={`${tab.value}-tab`} id={`${tab.value}-tab`} label={tab.label} sx={{ textTransform: 'none' }} />)}
      </Tabs>

      {tabs.map((tab, index) => <TabPanel key={`${tab.value}-panel`} id={`${tab.value}-panel`} value={value} index={index}>{tab.component}</TabPanel>)}

    </>
  );
}

export default System;
